<template>
	<div>
        <div class="cover" :style="{ backgroundImage: 'url(' + img_api + pageData.bannerImg + ')' }">
            <div class="front">
                <div class="title">
                    <div class="big_title">
                        {{ pageData.firstTitle }} </div>
                    <div class="transparent_title">{{
                        pageData.secondTitle }}
                    </div>
                </div>
                <div class="des">
                    {{ pageData.des }}
                </div>
            </div>
        </div>
		<!-- 面包屑 -->
		<div class="bread_box">
			<div class="crumb"><span class="your_position">您所在的位置:</span>
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/news' }">{{ pageData.firstTitle }}{{
						pageData.secondTitle }}</el-breadcrumb-item>
					<el-breadcrumb-item>详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>
		<div class="news_page">
			<div class="head">
				<div class="return_button" @click="goBack">返回列表页</div>
				<div class="news_title">{{ news.name }}</div>
				<div class="news_data">
					<span class="news_time">发布日期：{{ news.createDate }}</span>
					<span class="looks_num">浏览次数：{{ news.count }}</span>
				</div>
			</div>
			<div class="news_content">
				<p class="text11" v-html="news.details">
				</p>
			</div>
		</div>
	</div>
</template>


<script>
import cover from '../components/cover.vue'
import { getNewsDetails } from "@/server/https.js";
export default {
	name: '',
	components: {
		cover
	},
	data() {
		return {
			pageData: {
				firstTitle: '',
				secondTitle: '',
				bannerImg: '',
				des: '',
				path: this.$route.path
			},
            img_api: 'https://www.gdyuanwo.com/gdyuanwo/',
			news: {}
		}
	},
	mounted() {
		getNewsDetails({ newsId: this.$route.query.newsId }).then(res => {
			this.news = res.data.body.gpNews;
		});
		var setI = setInterval(() => {
			if (this.$store.state.headList != '') {
				var headList = this.$store.state.headList
				headList.map(item => {
					if (item.sort == 2) {
						let Name = item.name;
						this.pageData.firstTitle = Name.slice(0, -2);
						this.pageData.secondTitle = Name.substr(-2);
						this.pageData.bannerImg = item.image;
						this.pageData.des = item.details;
					}
				})
				clearInterval(setI)
			}
		}, 200)
	},
	methods: {
		goBack() {
			this.$router.go(-1); // 返回上一个路由
		}
		
	},
	beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true;
    next(0);
  },
};
</script>

<style scoped>
.cover {
    overflow: hidden;
    height: 355px;
    background-repeat: no-repeat;
	background-size: 100% 100%;
}

.front {
    margin-top: 72px;
    margin-left: 240px;
}

.title {
    display: flex;
}

.big_title {
    font-size: 68px;
    font-weight: bold;
    color: #FFFFFF;
}

.hight_title {
    display: flex;
    justify-content: center;
    flex-direction: row;
}

.cn_title {
    position: absolute;
    font-size: 48px;
    font-weight: bold;
    color: #13489D;
    z-index: 2;
}

.en_title {
    position: absolute;
    font-size: 54px;
    font-weight: bold;
    color: #C8D4E1;
}

.transparent_title {
    font-size: 68px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0);
    color: rgba(255, 255, 255, 0);
    -webkit-text-stroke: 1px #FFFFFF;
    text-stroke: 1px #FFFFFF;
}

.des {
    font-size: 24px;
    color: #FFFFFF;
}
.bread_box {
	overflow: hidden;
	height: 60px;
	background-color: #F7F8FA;
}

.crumb {
	display: flex;
	margin-top: 23px;
	margin-left: 140px;
}

.your_position {
	line-height: 1;
	font-size: 14px;
	font-weight: 400;
	color: #13489D;
	margin-right: 5px;
}

.news_page {
	width: 1000px;
	margin: auto;
}


.news_time {
	font-size: 12px;
	font-weight: 400;
	color: #999999;
}

.looks_num {
	font-size: 12px;
	font-weight: 400;
	color: #999999;
	margin-left: 40px;
}

.head {
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 20px;
	padding: 20px;
	border-bottom: 1px solid #d5d5d5;
}

.news_title {
	display: flex;
	justify-content: center;
	font-size: 24px;
	font-weight: 500;
	color: #333333;
	margin-bottom: 10px;
}

.news_data {
	display: flex;
	justify-content: center;
}

.return_button {
	width: 140px;
	height: 48px;
	background: #FFFFFF;
	border: 1px solid #5877BA;
	font-size: 18px;
	font-weight: 400;
	color: #13489D;
	line-height: 48px;
	text-align: center;
	position: absolute;
}

.return_button {
	cursor: pointer;
}

.news_content {
	margin-top: 20px;
}

.img_box {
	height: 630px;
}

.news_img {
	width: 100%;
	height: 100%;
	/* object-fit: contain; */
}

.text11 {
	font-size: 16px;
	font-weight: 400;
	color: #333333;
	text-indent: 25px;
	line-height: 2;
	margin-top: 30px;
	margin-bottom: 100px;
}
.text11>>> img{
	max-width: 100%;
}
</style>
